import script from "./search-filters.vue?vue&type=script&setup=true&lang=js"
export * from "./search-filters.vue?vue&type=script&setup=true&lang=js"

import "./search-filters.vue?vue&type=style&index=0&id=0200180b&lang=css"

const __exports__ = script;

export default __exports__